(function(){
    module.exports = class SymbolRule{
        constructor(){            
        }

        initialise(rules){
            this._rules = rules;
        }

        doesSymbolHaveRule(symbolId){
            return this._rules[""+symbolId] !== undefined;
        }

        isSymbolValid(){
            return true;
        }

        // number of symbols needed to satisfy rule, for groups it is the group count, for ditance it is the spacing
        getNumSymbolsNeeded(symbolId){
            if (!this.doesSymbolHaveRule(symbolId))
                return 0;

            return this._rules[""+symbolId].count;
        }

        getNumSymbolsToReserve(){
            return 0;
        }

        getAdditionalSymbolsNeededToSatisfyRule(symbolsInView){
            return [];
        }

        testReelBandPassesRule(reelBand) {
            return true;
        }
    }
}())